import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { orderBy } from 'lodash';
import { Subject, firstValueFrom, lastValueFrom, skip, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import {
  ExtendedKeycloakUser,
  StoreDropdowns,
} from 'src/app/shared/models/app-models';
import {
  BodyGetRFQDocument,
  OutputHistories,
  PrintDocument,
} from 'src/app/shared/models/database-models';
import { TabNavigationService } from 'src/app/shared/services/tab-navigation-service';

@Component({
  selector: 'app-output-history',
  templateUrl: './output-history.component.html',
  styleUrls: ['./output-history.component.scss'],
})
export class OutputHistoryComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Input() currentRoute = ['Purchase Modes'];
  breadCrumbFlow:string[]=['Purchase Modes'];
  currentPageString: string = 'Output history';
  activePage:string='Output history';
  pageSizeOptions: number[] = [5, 10, 20];
  mpDocumber: string = '';
  purchaseType: string = '';
  destroy$: Subject<boolean> = new Subject<boolean>();
  columnsToDisplay = [
    'VersionNumber',
    'Type',
    'RFQNumber',
    'Name',
    'Email',
    'ModifiedOn',
    'RFQDeadline',
    'CreatedBy',
    'TempStatus',
    'TempReason',
  ];
  dataOutputHistory: OutputHistories[] = [];
  dataSource: MatTableDataSource<OutputHistories> =
    new MatTableDataSource<OutputHistories>(this.dataOutputHistory);
  isLoading: boolean = false;
  KCUserList: ExtendedKeycloakUser[] = [];
  constructor(
    private tabNavService: TabNavigationService,
    private router: Router,
    private route: ActivatedRoute,
    private BackendApi: BackendApiService,
    private _snackBar: MatSnackBar,
    private store: Store<{ dp: StoreDropdowns }>
  ) {
    const previousPageName = sessionStorage.getItem('fromPage');
    if (previousPageName) {
      this.breadCrumbFlow = [previousPageName];
    } 
    const mpDocumber = this.route.snapshot.params['id'].split(';')[0] as string;
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(';')[0] as string;
    if (mpDocumber) {
      this.mpDocumber = mpDocumber;
      this.currentRoute.push(mpDocumber as string);
      this.breadCrumbFlow.push(mpDocumber as string);
    }
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (dp: StoreDropdowns) => {
        this.KCUserList = dp.UserList as ExtendedKeycloakUser[];
        try {
          this.isLoading = true
          //await new Promise(res => setTimeout(res, 5000));
          await this.getOutputHistory();
        } catch (e) {
          console.log('e', e);
        }
        finally {
          this.isLoading = false
        }
      });
  }

  async getOutputHistory() {
    if (this.KCUserList.length == 0) {
      this.KCUserList = (
        await firstValueFrom(this.store.select('dp').pipe(skip(1)))
      ).UserList as ExtendedKeycloakUser[];
    }
    // alert(this.mpDocumber)
    const data: any = await this.onGetOutputHistory(this.mpDocumber);
    this.dataOutputHistory = data.OutputHistory;
    for (const output of this.dataOutputHistory) {
      output.CreatedBy =
        this.KCUserList.find((user) => user.id == output.CreatedBy)?.last_name ??
        output.CreatedBy;
    }
    console.log(this.dataOutputHistory);
    this.dataOutputHistory = orderBy(
      this.dataOutputHistory,
      [(obj) => new Date(obj.ModifiedOn)],
      ['desc']
    );
    this.dataSource.data = this.dataOutputHistory;
    this.isLoading = false;
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  returnToRFQ = (): void => {
    // what is this code for ?????
    this.tabNavService.setSelectedTabIndex(1);
    this.router.navigateByUrl('/purchase/' + this.purchaseType + '/' + this.mpDocumber);
  };

  formatHeader(camelCaseHeader: string): string {
    const words = camelCaseHeader
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, function (str) {
        return str.toUpperCase();
      });
    return words;
  }

  async onDownloadZip(MPDocumentNumber: string, VendorNumber: string, RFQNumber: string, Version: number) {
    const body: BodyGetRFQDocument = {
      MPDocumentNumber,
      VendorNumber,
      RFQNumber,
      Version
    };
    try {
      const result: PrintDocument = await lastValueFrom(
        this.BackendApi.getRFQDocument(body).pipe(takeUntil(this.destroy$))
      );
      const arrayBuffer: any = result.Document.data;
      const int8Array = new Uint8Array(arrayBuffer);
      let file = new Blob([int8Array], { type: 'application/pdf' });
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (err) {
      this.openSnackBar('RFQ print failed to send.');
    }
  }

  async onGetOutputHistory(MPDocumentNumber: string) {
    try {
      // alert("sdf")
      return await lastValueFrom(
        this.BackendApi.getOutputHistory(MPDocumentNumber)
      );
    } catch {
      this.isLoading = false;
      throw Error('Backend problem');
    }
  }

  openSnackBar(notifMsg: string) {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: 'top',
      panelClass: 'snackbar-popup',
      duration: 5000,
    });
  }
}
